module.exports = __webpack_public_path__ + "platforms.3Oiu1dp3.svg";